import type { FragmentRefs } from "relay-runtime";
import type { Prettify } from "@skydio/core";
import type { Edge, NullableConnection } from "./connections";

// NOTE(sam): The Relay generated types don't exactly reflect what they look like at runtime so we
// need to do a bit of type finagling here.
export const isFragmentRef = <
  FragmentName extends string,
  FragmentType extends { " $fragmentSpreads": FragmentRefs<FragmentName> },
  DataType extends Record<string, unknown>,
>(
  value: FragmentType | DataType,
  fragmentName: FragmentName
): value is FragmentType => {
  if (
    "__fragments" in value &&
    fragmentName in (value as unknown as { __fragments: Record<string, unknown> }).__fragments
  ) {
    return true;
  }
  return false;
};

export type StripFragmentProperties<T> = Omit<T, " $fragmentType" | " $fragmentSpreads">;

type UnionMerge<T, U> = {
  [K in keyof T | keyof U]: K extends keyof T
    ? K extends keyof U
      ? T[K] extends any[]
        ? U[K] extends any[]
          ? Array<T[K][number] | U[K][number]> // Union for normal arrays
          : T[K] | U[K] // Union for mixed types (non-array)
        : T[K] extends NullableConnection<Edge<infer N>>
          ? U[K] extends NullableConnection<Edge<infer M>>
            ? NullableConnection<Edge<N | M>> // Union for Connection types
            : T[K] | U[K] // Union for mixed types (non-Connection)
          : T[K] extends object
            ? U[K] extends object
              ? UnionMerge<T[K], U[K]> // Recursively merge objects
              : T[K] | U[K] // Union for non-object types
            : T[K] | U[K] // Union for non-object types
      : T[K]
    : K extends keyof U
      ? U[K]
      : never;
};

interface BaseFragmentData {
  " $fragmentType": string;
}

interface FragmentDataWithTopLevelFragment extends BaseFragmentData {
  " $fragmentSpreads": FragmentRefs<any>;
}

type SpreadNestedFragmentFields<
  FragmentData extends BaseFragmentData,
  NestedFragmentFields,
> = Prettify<UnionMerge<StripFragmentProperties<FragmentData>, NestedFragmentFields>>;

type TopLevelUnpackedFragmentData<
  FragmentData extends FragmentDataWithTopLevelFragment,
  TopLevelFragmentFields extends object,
> = Prettify<Pick<FragmentData, keyof FragmentDataWithTopLevelFragment>> | TopLevelFragmentFields;

/**
 *
 */
export type UnpackedFragmentData<
  FragmentData extends BaseFragmentData,
  NestedFragmentFields extends object | void = void,
  TopLevelFragmentFields extends object | void = void,
> = TopLevelFragmentFields extends object
  ? FragmentData extends FragmentDataWithTopLevelFragment
    ? NestedFragmentFields extends object
      ? // Top-level and nested fragment fields
        SpreadNestedFragmentFields<FragmentData, NestedFragmentFields> &
          Prettify<TopLevelUnpackedFragmentData<FragmentData, TopLevelFragmentFields>>
      : // Only top-level fragment fields
        StripFragmentProperties<FragmentData> &
          Prettify<TopLevelUnpackedFragmentData<FragmentData, TopLevelFragmentFields>>
    : never // Not a valid fragment for top-level fragment fields
  : NestedFragmentFields extends object
    ? // Only nested fragment fields
      SpreadNestedFragmentFields<FragmentData, NestedFragmentFields>
    : // No added fragment fields, just simplify the fragment data
      Prettify<StripFragmentProperties<FragmentData>>;
